import {
  Button,
  Field,
  FieldDescription,
  FieldError,
  FieldGroup,
  FieldLabel,
  Input,
} from "@base/ui";
import { useState, type FormEvent } from "react";
import type { UsuarioComConvite } from "@base/contracts";
import { useCriarUsuario } from "../application/use-usuarios";
import { mensagemDoErro } from "../../../shared/http/mensagem-de-erro";

/**
 * Cadastro de alguem da equipe Monte. Nao pede senha: a pessoa recebe um
 * convite por e-mail e define a propria.
 */
export function FormularioDeNovoUsuario({
  aoCriar,
}: {
  readonly aoCriar: (criado: UsuarioComConvite) => void;
}) {
  const criar = useCriarUsuario();
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const campos = criar.error ? errosPorCampo(criar.error) : {};

  function enviar(evento: FormEvent<HTMLFormElement>) {
    evento.preventDefault();
    // Pessoa de clinica entra pela tela Pessoas, ja vinculada ao cliente.
    const dados = { nome: nome.trim(), email: email.trim().toLowerCase(), papel: "admin" as const };
    criar.mutate(dados, { onSuccess: aoCriar });
  }

  return (
    <form onSubmit={enviar} noValidate className="flex flex-col gap-6">
      <FieldGroup>
        <Field data-invalid={campos.nome ? true : undefined}>
          <FieldLabel htmlFor="novo-nome">Nome</FieldLabel>
          <Input
            id="novo-nome"
            autoComplete="off"
            value={nome}
            onChange={(evento) => setNome(evento.target.value)}
            required
          />
          {campos.nome ? <FieldError>{campos.nome}</FieldError> : null}
        </Field>
        <Field data-invalid={campos.email ? true : undefined}>
          <FieldLabel htmlFor="novo-email">E-mail</FieldLabel>
          <Input
            id="novo-email"
            type="email"
            autoComplete="off"
            value={email}
            onChange={(evento) => setEmail(evento.target.value)}
            required
          />
          <FieldDescription>O convite para criar a senha vai para este endereço.</FieldDescription>
          {campos.email ? <FieldError>{campos.email}</FieldError> : null}
        </Field>
        {criar.isError && Object.keys(campos).length === 0 ? (
          <FieldError>{mensagemDoErro(criar.error)}</FieldError>
        ) : null}
        <Button type="submit" disabled={criar.isPending || !nome || !email}>
          {criar.isPending ? "Enviando convite…" : "Cadastrar e enviar convite"}
        </Button>
      </FieldGroup>
    </form>
  );
}

/** Erros por campo do Problem Details (422), ja traduzidos para o formulario. */
function errosPorCampo(erro: unknown): Partial<Record<"nome" | "email", string>> {
  const campos =
    typeof erro === "object" && erro !== null && "campos" in erro
      ? (erro as { campos: Readonly<Record<string, readonly string[]>> }).campos
      : {};
  return {
    ...(campos.nome?.length ? { nome: "Informe um nome com pelo menos 3 letras." } : {}),
    ...(campos.email?.length ? { email: "Informe um e-mail válido." } : {}),
  };
}
